<template>
  <span>
    <v-row>
      <v-col cols="12" sm="6">
        <keep-alive>
          <ContactsAutocomplete
            v-model="priceList.contact_id"
            :notRequired="true"
            clearable
            :disabled="priceList.for_group_of_contacts || inputsDisabled"
            @input="handleContactChange"
          />
        </keep-alive>
      </v-col>
      <v-col cols="12" sm="6" class="d-flex align-items-center">
        <v-switch
          v-model="priceList.for_group_of_contacts"
          class="group-of-contacts-switch"
          :disabled="inputsDisabled"
          @change="handleForGroupOfContactsChange"
        />
        {{ $t('PRICE_LISTS.FOR_GROUP_OF_CONTACTS') }}
      </v-col>
    </v-row>
    <template v-if="priceList.for_group_of_contacts">
      <v-row>
        <v-col cols="12">
          <span class="contacts-found-label">
            {{ `${$t('GENERAL.LABELS.SELECTED')} ${priceList.contacts_count} ${$t('GENERAL.LABELS.CONTACTS')}:` }}
          </span>
          <span class="contacts-found-list text-primary" @click="showContactsDialog = true">
            {{ $t('GENERAL.LABELS.LIST_OF_THE_CONTACTS') }}
          </span>
          <ContactsDialog
            v-model="showContactsDialog"
            :server-data-options="{
              method: contactsTableItemsMethod,
              params: { priceListId: $route.params.id }
            }"
            :inputsDisabled="inputsDisabled"
            :hasSelected="priceList.contacts_count > 0"
            @contact-selection="handleContactSelection"
            @all-selected-change="handleAllContactsSelectedChange"
            @dialog-close="showContactsDialog = false"
          />
        </v-col>
      </v-row>
    </template>
  </span>
</template>

<script>
import { SHOW_SNACK } from "@/store/snack.module";
import ContactsDialog from "@/views/pages/priceLists/partials/ContactsDialog.vue";
import ContactsAutocomplete from "@/views/tagProcessor/Input/ContactsAutocomplete.vue";
import {
  UPDATE_PRICE_LIST_CONTACT,
  UPDATE_PRICE_LIST_FOR_GROUP_OF_CONTACTS,
  GET_PRICE_LIST_CONTACTS,
  UPDATE_PRICE_LIST_CONTACT_SELECTION,
  UPDATE_PRICE_LIST_ALL_CONTACTS_SELECTED
} from "@/store/priceLists.module";

export default {
  components: {
    ContactsDialog,
    ContactsAutocomplete
  },

  props: {
    priceList: {
      type: Object,
      required: true
    },
    temps: {
      type: Array,
      default: () => []
    },
    countries: {
      type: Array,
      default: () => []
    },
    incoterms: {
      type: Array,
      default: () => []
    },
    inputsDisabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      showContactsDialog: false
    };
  },

  methods: {
    contactsTableItemsMethod: GET_PRICE_LIST_CONTACTS,

    handleContactChange(value) {
      this.$emit("set-processing", true);
      this.$store
        .dispatch(UPDATE_PRICE_LIST_CONTACT, {
          priceListId: this.$route.params.id,
          contact_id: value
        })
        .then(response => {
          this.$emit("price-list-updated", response);
        })
        .catch(() => {
          this.$store.dispatch(SHOW_SNACK, {
            color: "error",
            text: this.$t("GENERAL.UNEXPECTED_ERROR")
          });
        })
        .finally(() => {
          this.$emit("set-processing", false);
        });
    },

    handleForGroupOfContactsChange(value) {
      this.$emit("set-processing", true);
      this.$store
        .dispatch(UPDATE_PRICE_LIST_FOR_GROUP_OF_CONTACTS, {
          priceListId: this.$route.params.id,
          for_group_of_contacts: value
        })
        .then(response => {
          this.$emit("price-list-updated", response);
        })
        .catch(() => {
          this.$store.dispatch(SHOW_SNACK, {
            color: "error",
            text: this.$t("GENERAL.UNEXPECTED_ERROR")
          });
        })
        .finally(() => {
          this.$emit("set-processing", false);
        });
    },

    handleContactSelection(payload) {
      this.$store
        .dispatch(UPDATE_PRICE_LIST_CONTACT_SELECTION, {
          priceListId: this.$route.params.id,
          ...payload
        })
        .then(response => {
          this.$emit("price-list-updated", response);
        });
    },

    handleAllContactsSelectedChange() {
      this.$store
        .dispatch(UPDATE_PRICE_LIST_ALL_CONTACTS_SELECTED, {
          priceListId: this.$route.params.id
        })
        .then(response => {
          this.$emit("price-list-updated", response);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.group-of-contacts-switch {
  margin-top: 0;
  padding-top: 0;
}

.contacts-found-list {
  cursor: pointer;
  text-decoration: underline;
}
</style>
